<template>
  <WdsStack direction-row justify-space-between>
    <WdsStack direction-row items-center gap-xs>
      <WdsButtonGhost v-if="previousTab" secondary @click="changeToPreviousTab">
        <WdsStack align-center gap-sm>
          <WdsIcon name="arrow-left" :size="16" />
          {{ previousTab.label }}
        </WdsStack>
      </WdsButtonGhost>
    </WdsStack>

    <WdsStack direction-row items-center gap-xs>
      <template v-if="nextTab">
        <WdsText class="tw-pt-0.5">{{ $t('Next:') }}</WdsText>

        <WdsButtonGhost secondary @click="changeToNextTab">
          <WdsStack align-center gap-sm>
            {{ nextTab.label }}
            <WdsIcon name="arrow-right" :size="16" />
          </WdsStack>
        </WdsButtonGhost>
      </template>
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsButtonGhost, WdsIcon, WdsStack, WdsText } from '@worksome/wds-components'

import { $t } from '@/app-bootstrapping/SetUpInternationalization'

import { JOB_TAB } from '@/components/Job/constants'
import { useJobFormStore } from '@/components/Job/Edit/store/jobFormStore'

const emit = defineEmits(['update:active-tab-key'])

const jobStore = useJobFormStore()

const tabs = [
  { key: JOB_TAB.OVERVIEW, label: $t('Overview') },
  { key: JOB_TAB.DETAILS, label: $t('Details') },
  { key: JOB_TAB.BUDGET, label: $t('Budget') },
  { key: JOB_TAB.SETTINGS, label: $t('Settings') },
]

const currentTabIndex = computed(() => tabs.findIndex((tab) => tab.key === jobStore.activeTabKey))

const previousTab = computed(() => tabs[currentTabIndex.value - 1] ?? null)
const nextTab = computed(() => tabs[currentTabIndex.value + 1] ?? null)

const changeTab = (tab: JOB_TAB) => {
  emit('update:active-tab-key', tab)

  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  })
}

const changeToPreviousTab = () => {
  if (previousTab.value) {
    changeTab(previousTab.value.key)
  }
}

const changeToNextTab = () => {
  if (nextTab.value) {
    changeTab(nextTab.value.key)
  }
}
</script>
